import Glide from "@glidejs/glide";
import { forAllCallback } from "../../../scripts/utils/helpers";

export default () => {
    forAllCallback(".content-block.content-block--slider", (el) => {
        const glideEl = el.querySelector(".glide");
        const glide = new Glide(glideEl, {
            type: "carousel",
        });
        glide.mount();
    });
};
